import { render, staticRenderFns } from "./RegionColorSettingsForm.vue?vue&type=template&id=1383715c&"
import script from "./RegionColorSettingsForm.vue?vue&type=script&lang=js&"
export * from "./RegionColorSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports